module.exports = __webpack_public_path__ + "static/media/plus1.3864174a.svg";